import { render, staticRenderFns } from "./entityView.vue?vue&type=template&id=04a049c2&"
import script from "./entityView.vue?vue&type=script&lang=js&"
export * from "./entityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports